import { render, staticRenderFns } from "./VehicleRoute.vue?vue&type=template&id=c31af27a&scoped=true"
import script from "./VehicleRoute.vue?vue&type=script&lang=js"
export * from "./VehicleRoute.vue?vue&type=script&lang=js"
import style0 from "./VehicleRoute.vue?vue&type=style&index=0&id=c31af27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31af27a",
  null
  
)

export default component.exports